import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementMetric extends StoryElementBase {
	type = StoryElementType.METRIC;
	longTitle = 'Metric name';

	override get isLoading(): boolean {
		return super.isLoading || !this.primaryMetricData;
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		let text = '';

		const primaryMetricData = this.primaryMetricData;
		if (primaryMetricData) {
			this.addLayoutForSourceAndMetric(node, primaryMetricData);
		} else {
			text = '<unknown>';
			node.textContent = text;
		}
	}
}
